"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualMenuItem = void 0;
var Utilities_1 = require("../../Utilities");
var ContextualMenuItem_base_1 = require("./ContextualMenuItem.base");
var ContextualMenu_classNames_1 = require("./ContextualMenu.classNames");
/**
 * ContextualMenuItem description
 */
exports.ContextualMenuItem = (0, Utilities_1.styled)(ContextualMenuItem_base_1.ContextualMenuItemBase, ContextualMenu_classNames_1.getItemStyles, undefined, { scope: 'ContextualMenuItem' });
//# sourceMappingURL=ContextualMenuItem.js.map